import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing cubic functions.
 * Focus: S-curve with inflection point.
 */
export const CUBIC_PRESET: GraphpadWidgetConfig = {
  id: 'cubic',
  type: 'graphpad',
  params: {
    f: {
      type: 'cubic',
      params: { a: 0.5, h: -2, k: -2 },
    },
    'f-translate': {
      type: 'handle',
      params: { of: 'f', behavior: 'translate' },
    },
    'f-roots': {
      type: 'roots',
      params: { of: 'f' },
    },
    'f-inflection': {
      type: 'inflection',
      params: { of: 'f' },
    },
    'y-intercept': {
      type: 'yIntercept',
      params: { of: 'f' },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -5, xEnd: 3, yStart: -6, yEnd: 6 },
      grid: { type: 'lines', visible: false },
    },
    elements: {
      'f-roots': {
        point: { label: { contentVariant: 'name+coord', position: 'topLeft' } },
      },
      'f-inflection': {
        point: { label: { contentVariant: 'name+coord', position: 'topLeft' } },
      },
      'y-intercept': {
        point: { label: { contentVariant: 'name+coord', position: 'topLeft' } },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'a (scale)',
        param: 'f.a',
        range: [-2, 2, 0.1],
        defaultValue: 0.5,
        editable: true,
        color: 'indigo',
      },
      {
        id: 'slider-h',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'h (x-shift)',
        param: 'f.h',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-k',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'k (y-shift)',
        param: 'f.k',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'amber',
      },
    ],
  },
};
